export default function convertBankToPersianName(name) {
  switch (name) {
    case "MELLI_IRAN":
      return { name: "بانک ملی ایران", logo: "/images/banks/melli.svg" };
    case "SEPAH":
      return { name: "بانک سپه", logo: "/images/banks/sepah.svg" };
    case "SANAT_MADAN":
      return { name: "بانک صنعت و معدن", logo: "/images/banks/sanatmadan.svg" };
    case "KESHAVARZI":
      return { name: "بانک کشاورزی", logo: "/images/banks/keshavarzi.svg" };
    case "MASKAN":
      return { name: "بانک مسکن", logo: "/images/banks/maskan.svg" };
    case "TOSSE_SADERAT_IRAN":
      return {
        name: "بانک توسعه صادرات ایران",
        logo: "/images/banks/toseesaderat.svg",
      };
    case "TOSSE_TAAVON":
      return {
        name: "بانک توسعه تعاون",
        logo: "/images/banks/toseetaavon.svg",
      };
    case "POST_BANK_IRAN":
      return { name: "پست بانک ایران", logo: "/images/banks/postbank.svg" };
    case "EGHTESAD_NOVIN":
      return {
        name: "بانک اقتصاد نوین",
        logo: "/images/banks/eghtesadnovin.svg",
      };
    case "PARSIAN":
      return { name: "بانک پارسیان", logo: "/images/banks/parsian.svg" };
    case "KARAFARIN":
      return { name: "بانک کارآفرین", logo: "/images/banks/karafarin.svg" };
    case "SAMAN":
      return { name: "بانک سامان", logo: "/images/banks/saman.svg" };
    case "SINA":
      return { name: "بانک سینا", logo: "/images/banks/sina.svg" };
    case "KHAVARMIANEH":
      return { name: "بانک خاورمیانه", logo: "/images/banks/khavarmiane.svg" };
    case "SHAHR":
      return { name: "بانک شهر", logo: "/images/banks/shahr.svg" };
    case "DAY":
      return { name: "بانک دی", logo: "/images/banks/dey.svg" };
    case "SADERAT":
      return { name: "بانک صادرات", logo: "/images/banks/saderat.svg" };
    case "MELLAT":
      return { name: "بانک ملت", logo: "/images/banks/mellat.svg" };
    case "TEJARAT":
      return { name: "بانک تجارت", logo: "/images/banks/tejarat.svg" };
    case "REFAH":
      return { name: "بانک رفاه", logo: "/images/banks/refah.svg" };
    case "AYANDEH":
      return { name: "بانک آینده", logo: "/images/banks/ayandeh.svg" };
    case "GARDASHGARI":
      return { name: "بانک گردشگری", logo: "/images/banks/gardeshgari.svg" };
    case "IRAN_ZAMIN":
      return { name: "بانک ایران زمین", logo: "/images/banks/iranzamin.svg" };
    case "SARMAYEH":
      return { name: "بانک سرمایه", logo: "/images/banks/sarmaye.svg" };
    case "PASARGAD":
      return { name: "بانک پاسارگاد", logo: "/images/banks/pasargad.svg" };
    case "IRAN_VENEZUELA":
      return { name: "بانک مشترک ایران و ونزوئلا", logo: null };
    case "MEHR_IRAN":
      return {
        name: "بانک قرض الحسنه مهر ایران",
        logo: "/images/banks/mehriran.svg",
      };
    case "RESALAT":
      return {
        name: "بانک قرض الحسنه رسالت",
        logo: "/images/banks/resalat.svg",
      };
    case "KOSAR":
      return { name: "موسسه اعتباری کوثر", logo: "/images/banks/kosar.svg" };
    case "GHESTA_LOAN":
      return { name: "کارت خرید قسطا", logo: "/images/banks/ayandeh.svg" };
    case "UNKNOWN":
      return { name: "بانک نامشخص", logo: null };
    default:
      return { name: "بانک نامشخص", logo: null };
  }
}
